import vue from 'vue'
import VueRouter from 'vue-router'

vue.use(VueRouter)
export default function Router (options, store) {
  const routeConfig = makeRouterConfig(options?.router)
  const router = new VueRouter(routeConfig)

  router.beforeEach((to, from, next) => {
    next()
  })

  return router
}

export const makeRouterConfig = () => {
  const innerRouter = [
    {
      path: '/',
      name: 'RMain',
      meta: { title: '招生' },
      component: () => import('../views/RMain'),
    },
    {
      path: '/noticeList',
      name: 'RNotice',
      meta: { title: '公告' },
      component: () => import('../views/RNotice'),
    },
    {
      path: '/noticeDetail',
      name: 'RNoticeDetail',
      meta: { title: '公告详情' },
      component: () => import('../views/RNotice/RNoticeDetail'),
    },
    {
      path: '/message',
      name: 'RMessage',
      meta: { title: '消息' },
      component: () => import('../views/RMessage'),
    },
    {
      path: '/messageDetail',
      name: 'RMessageDetail',
      meta: { title: '消息详情' },
      component: () => import('../views/RMessage/RMessageDetail'),
    },
    {
      path: '/service',
      name: 'RService',
      meta: { title: '服务' },
      component: () => import('../views/RService'),
    },
    {
      path: '/myself',
      name: 'RMyself',
      meta: { title: '我的' },
      component: () => import('../views/RMyself'),
    },
    {
      path: '/login',
      name: 'RLogin',
      meta: { title: '登录' },
      component: () => import('../views/RLogin'),
    },
    {
      path: '/register',
      name: 'RRegister',
      meta: { title: '注册' },
      component: () => import('../views/RLogin/RRegister'),
    },
    {
      path: '/forgetPassWord',
      name: 'RForgetPassword',
      meta: { title: '忘记密码' },
      component: () => import('../views/RLogin/RForgetPassword'),
    },
    {
      path: '/modifyPassword',
      name: 'RModifyPassword',
      meta: { title: '修改密码' },
      component: () => import('../views/RLogin/RModifyPassword'),
    },
    {
      path: '/enrollList',
      name: 'REnrollList',
      meta: { title: '报名信息' },
      component: () => import('../views/enrollList/REnrollList'),
    },
    {
      path: '/enroll',
      name: 'REnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/enroll/REnroll'),
    },
    {
      path: '/njrtsEnroll',
      name: 'RNjrtsEnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/enroll/RNjrtsEnroll'),
    },
    {
      path: '/enrollDetail',
      name: 'REnrollDetail',
      meta: { title: '报名信息' },
      component: () => import('../views/enrollList/REnrollDetail'),
    },
    {
      path: '/chooseEnrollType',
      name: 'RChooseEnrollType',
      meta: { title: '报名' },
      component: () => import('../views/enroll/RChooseEnrollType'),
    },
    {
      path: '/startEnroll',
      name: 'RStartEnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/enroll/RStartEnroll'),
    },
    {
      path: '/exam',
      name: 'RExam',
      meta: { title: '准考证下载' },
      component: () => import('../views/exam'),
    },
    {
      path: '/gardeSearch',
      name: 'RGardeSearch',
      meta: { title: '成绩查询' },
      component: () => import('../views/gardeSearch'),
    },
    {
      path: '/qualifSearch',
      name: 'RQualifSearch',
      meta: { title: '校考资格查询' },
      component: () => import('../views/qualifSearch'),
    },
    {
      path: '/enrollSearch',
      name: 'REnrollSearch',
      meta: { title: '录取查询' },
      component: () => import('../views/enrollSearch'),
    },
    {
      path: '/njrtsEnrollSearch',
      name: 'RNjrtsEnrollSearch',
      meta: { title: '录取查询' },
      component: () => import('../views/njrtsEnrollSearch'),
    },
    {
      path: '/enrollPrepareSearch',
      name: 'REnrollPrepareSearch',
      meta: { title: '拟录取查询' },
      component: () => import('../views/enrollPrepareSearch'),
    },
    {
      path: '/payFor',
      name: 'RPayFor',
      meta: { title: '缴费查询' },
      component: () => import('../views/payFor'),
    },
    {
      path: '/payNotice',
      name: 'RPayNotice',
      meta: { title: '缴费须知' },
      component: () => import('../views/payFor/RPayNotice'),
    },
    {
      path: '/otherPay',
      name: 'ROtherPay',
      meta: { title: '缴费' },
      component: () => import('../views/payFor/ROtherPay'),
    },
    {
      path: '/payDetail',
      name: 'RPayDetail',
      meta: { title: '缴费详情' },
      component: () => import('../views/payFor/RPayDetail'),
    },
    {
      path: '/startPay',
      name: 'RStartPay',
      meta: { title: '开始缴费' },
      component: () => import('../views/payFor/RStartPay'),
    },
    {
      path: '/preparePayFor',
      name: 'RPreparePayFor',
      meta: { title: '预科缴费查询' },
      component: () => import('../views/preparePayFor/RPrepayPayFor'),
    },
    {
      path: '/preparePayNotice',
      name: 'RPreparePayNotice',
      meta: { title: '预科缴费须知' },
      component: () => import('../views/preparePayFor/RPreparePayNotice'),
    },
    {
      path: '/prepareOtherPay',
      name: 'RPrepareOtherPay',
      meta: { title: '缴费' },
      component: () => import('../views/preparePayFor/RPrepareOtherPay'),
    },
    {
      path: '/preparePayDetail',
      name: 'RPreparePayDetail',
      meta: { title: '缴费详情' },
      component: () => import('../views/preparePayFor/RPreparePayDetail'),
    },
    {
      path: '/prepareStartPay',
      name: 'RPrepareStartPay',
      meta: { title: '开始缴费' },
      component: () => import('../views/preparePayFor/RPrepareStartPay'),
    },
    {
      path: '/auth',
      name: 'RAuth',
      meta: { title: '授权中' },
      component: () => import('../views/RAuth'),
    },
    {
      path: '/serviceContent',
      name: 'RServiceContent',
      meta: { title: '服务内容' },
      component: () => import('../views/serviceContent'),
    },
    {
      path: '/enrollNotice',
      name: 'REnrollNotice',
      meta: { title: '免试申请' },
      component: () => import('../views/enroll/REnrollNotice'),
    },
    {
      path: '/noExamApplication',
      name: 'RNoExamApplication',
      meta: { title: '免试申请' },
      component: () => import('../views/otherApplication/RNoExamApplication'),
    },

    {
      path: '/policyApplication',
      name: 'RPolicyApplication',
      meta: { title: '政策申请' },
      component: () => import('../views/otherApplication/RPolicyApplication'),
    },
    {
      path: '/specialApplication',
      name: 'RSpecialApplication',
      meta: { title: '特殊申请' },
      component: () => import('../views/otherApplication/RSpecialApplication'),
    },
    {
      path: '/startOtherSpecial',
      name: 'RStartOtherSpecial',
      meta: { title: '特殊申请' },
      component: () => import('../views/otherApplication/startOtherSpecial/RStartOtherSpecial'),
    },
    {
      path: '/reviewApplication',
      name: 'RReviewApplication',
      meta: { title: '成绩复核申请' },
      component: () => import('../views/RReviewApplication'),
    },
    {
      path: '/startReviewApplication',
      name: 'RStartReviewApplication',
      meta: { title: '成绩复核申请' },
      component: () => import('../views/RReviewApplication/RStartReviewApplication'),
    },
    {
      path: '/reviewApplicationDetail',
      name: 'RReviewApplicationDetail',
      meta: { title: '成绩复核申请' },
      component: () => import('../views/RReviewApplication/RReviewApplicationDetail'),
    },
    {
      path: '/otherSpecialDetail',
      name: 'ROtherSpecialDetail',
      meta: { title: '特殊申请详情' },
      component: () => import('../views/otherApplication/ROtherSpecialDetail'),
    },
    {
      path: '/TOtherPage/:level',
      name: 'TOtherPage',
      noNeedLogin: true,
      noNeedAuth: true,
      meta: { title: '操作' },
      props: true,
      component: () => import('../components/CJumpPage/TOtherPage'),
    },
    {
      path: '/choosePrepareEnrollType',
      name: 'RChoosePrepareEnrollType',
      meta: { title: '报名' },
      component: () => import('../views/prepareEnroll/RChoosePrepareEnrollType'),
    },
    {
      path: '/startPrepareEnroll',
      name: 'RStartPrepareEnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/prepareEnroll/RStartPrepareEnroll'),
    },
    {
      path: '/prepareEnroll',
      name: 'RPrepareEnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/prepareEnroll/RPrepareEnroll'),
    },
    {
      path: '/psyTest',
      name: 'RPsyTest',
      meta: { title: '测评' },
      component: () => import('../views/prepareRelation/RPsyTest'),
    },
    {
      path: '/psyTestResult',
      name: 'RPsyTestResult',
      meta: { title: '测评' },
      component: () => import('../views/prepareRelation/RPsyTest/RPsyTestResult'),
    },
    {
      path: '/prepareEnrollNotice',
      name: 'RPrepareEnrollNotice',
      meta: { title: '免试申请' },
      component: () => import('../views/prepareEnroll/RPrepareEnrollNotice'),
    },
    {
      path: '/prepareEnrollList',
      name: 'RPrepareEnrollList',
      meta: { title: '报名信息' },
      component: () => import('../views/prepareEnrollList/RPrepareEnrollList'),
    },
    {
      path: '/prepareEnrollDetail',
      name: 'RPrepareEnrollDetail',
      meta: { title: '报名信息' },
      component: () => import('../views/prepareEnrollList/RPrepareEnrollDetail'),
    },
    {
      path: '/checkIdentify',
      name: 'RCheckIdentify',
      meta: { title: '身份核验' },
      component: () => import('../views/RCheckIdentify'),
    },
    {
      path: '/checkIdentify2',
      name: 'RCheckIdentify2',
      meta: { title: '身份核验' },
      component: () => import('../views/RCheckIdentify/RCheckIdentify2'),
    },
    {
      path: '/REnrollCheckIdentify',
      name: 'REnrollCheckIdentify',
      meta: { title: '身份核验' },
      component: () => import('../views/REnrollCheckIdentify'),
    },
    {
      path: '/REnrollHandWriting',
      name: 'REnrollHandWriting',
      meta: { title: '电子签名' },
      component: () => import('../views/REnrollHandWriting'),
    },
    {
      path: '/myOwnEnroll',
      name: 'RMyOwnEnroll',
      meta: { title: '报名信息' },
      component: () => import('../views/RMyOwnEnroll'),
    },
    {
      path: '/myOwnPay',
      name: 'RMyOwnPay',
      meta: { title: '缴费信息' },
      component: () => import('../views/RMyOwnPay'),
    },
    {
      path: '/myQrcode',
      name: 'RMyQrcode',
      meta: { title: '二维码' },
      component: () => import('../views/RMyQrcode'),
    },
    {
      path: '/crEnrollResult',
      name: 'RCrEnrollResult',
      meta: { title: '报名结果' },
      component: () => import('../views/crEnroll/crEnrollResult/RCrEnrollResult'),
    },
    {
      path: '/qtEnrollResult',
      name: 'RQtEnrollResult',
      meta: { title: '报名结果' },
      component: () => import('../views/qtEnroll/RQtEnrollResult.vue'),
    },
    {
      path: '/qtGardeSearch',
      name: 'RQtGardeSearch',
      meta: { title: '成绩查询' },
      component: () => import('../views/qtGarde/RQtGardeSearch.vue'),
    },
    {
      path: '/enrollChangeApply',
      name: 'REnrollChangeApply',
      meta: { title: '专业意向采集' },
      component: () => import('../views/enrollChangeApply/REnrollChangeApply'),
    },
  ]

  return { routes: innerRouter }
}
